<template>
  <footer class="app-footer">
    <span><!-- a v-bind:href="$t('COMPANYURL')">{{$t('COMPANYNAMEFOOTER')}}</a --> {{$t('COPYRIGHTINFO')}}</span>
    <!-- span class="ml-auto">{{$t('POWEREDBY')}} <a v-bind:href="$t('COREAPPSURL')">{{$t('COREAPSNAME')}}</a></span -->
    <span class="ml-auto"><a href="https://directdesign.hr/en/">DIRECT DESIGN</a> | <a href="https://directdesign.hr/en/web-development/">Web Development</a> | <a href="https://directdesign.hr/en/graphic-design/">Graphic Design</a> | <a href="https://directdesign.hr/en/internet-marketing/">Internet marketing (SEO)</a></span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script> 
